var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{active : _vm.isActive},attrs:{"id":"snackbar"}},[_c('span',{class:_vm.config.type,domProps:{"innerHTML":_vm._s(_vm.config.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }